import type { IDiscountBannerConfig } from "app/@types/ISwSettings";

export interface IDiscountConfig {
    startDate: string;
    endDate: string;
}

interface IMergeDiscountConfig {
    base: IDiscountConfig;
    gbDiscountEndDate?: string;
    customData?: { DiscountBannerConfig?: IDiscountBannerConfig } | null;
}

export const mergeDiscountDateConfig = ({ base, gbDiscountEndDate }: IMergeDiscountConfig): IDiscountConfig => {
    const startDate = base.startDate;
    let endDate = base.endDate;

    if (gbDiscountEndDate) {
        endDate = gbDiscountEndDate;
    }

    return {
        startDate,
        endDate,
    };
};
